import { cn } from '@/lib/utils/utils';
import { Button } from '@/components/ui/button';

export function TabSwitcher({ tabs, activeTab, onChange, className }) {
    return (
        <div className={cn('flex items-center gap-1 w-full bg-surface rounded-xl p-1 border border-border', className)}>
            {tabs.map((tab) => (
                <Button
                    variant="plain"
                    color="neutral"
                    size="xmd"
                    key={tab.value}
                    onClick={() => onChange(tab.value)}
                    className={cn(
                        'flex-1 py-2 rounded-lg text-sm font-medium transition-colors',
                        activeTab === tab.value
                            ? 'bg-primary text-primary-foreground'
                            : 'bg-transparent text-muted-foreground hover:text-foreground',
                    )}
                >
                    {tab.label}
                </Button>
            ))}
        </div>
    );
}
